module.exports = __webpack_public_path__ + "img/aiVipImg.57cda6f9.jpg";